module.exports = __webpack_public_path__ + "static/img/right-arrow-triangle-green.a8ef8f4.svg";


//////////////////
// WEBPACK FOOTER
// ./static/website/images/right-arrow-triangle-green.svg
// module id = 9RJL
// module chunks = 4